//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShareQuestion from '../../questionnaire/components/ShareQuestion.vue'
import { jssdk, isIphonex } from '@runwork/runwork-help'

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
  },
  data() {
    return {}
  },
  methods: {
    addQuestion() {
      if (this.$isHarmony) {
        new this.$Dialog({
          title: '温馨提示',
          text: `该功能暂不支持鸿蒙系统`,
          theme: 'ios',
          isConfirm: false
        });
        return;
      }
      new this.$Popup(ShareQuestion, {
        position: 'bottom',
        isMaskClose: false,
        size: '140px',
        item: this.question,
      })
    },
    goQuestion() {
      this.$emit('onadd')
    },
  },
}
